<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div class="row mb-3">
            <div class="col-sm-12 col-md-4">
                <div class="dataTables_filter">
                    <label class="d-flex mb-0">
                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="search" @keypress.enter="filterSearch">
                        <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearch">
                            <i class="fas fa-search"></i>
                        </button>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <date-range-picker class="w-100"
                    :minDate="minDate"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="false"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    @showCustomRange="showCustomRangeCalendars=true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-4 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect  :value="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="showVoided" @change="filterVoided($event)" v-model="isVoided">
            <label class="custom-control-label" for="showVoided">{{$t('label.show_voided')}}</label>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

export default {
    name: 'orderFilter',
    components:{
        DateRangePicker
    },
    data(){
        let startDate = moment().startOf('month').toDate();
        let endDate = moment().endOf('month').toDate()
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            search: "",
            dateRange: { startDate, endDate },
            outlet: [{id: "all", text:this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}], selectedOutlet: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})},
            isVoided: false,
            exportHeaders: [], exportFields: {}, exportData: [], exportFileName: "",
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.outlet = [{id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...JSON.parse(this.$store.state.outlets))

            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)[0]
        }
    },
    methods:{
         filterSearch(){
            this.setFilter()
        },
        filterVoided(e){
            this.isVoided = e.target.checked ? true : false;
            this.setFilter()
        },
        filterByOutlet(item){
            this.selectedOutlet = item
            this.setFilter()
        },
        filterByDate(date){
            this.dateRange = date
            this.setFilter()
        },
        setFilter(){
            var data = {
                date: this.dateRange,
                search: this.search,
                outlet: this.selectedOutlet,
                voided: this.isVoided,
            }
            this.$emit('filterOrder', data)
        },
        setExportData(item){
            this.exportData = item.exportData
            this.exportFields = item.exportFields
            this.exportFileName = item.exportFileName
            this.exportHeaders = item.exportHeaders
        },
    },
    mounted(){
        let $vm = this
        var outlets = JSON.parse($vm.$store.state.outlets);
        $vm.outlet.push(...outlets);

        if (this.outlet[1]) {
            this.selectedOutlet = this.outlet[1]
        }

        $vm.setFilter()
    }
}
</script>